import React, {Fragment, useState, useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import StyleConfig from '../components/styleConfig';
import {fetchConfig} from '../reducer/config-reducer';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import '../sass/index.scss';

interface configObject {
  configReducer: any;
}
interface indexProps {
  fetchConfig(): any;
  configProp: any;
}

const Index = (props: indexProps) => {
  const [config, setConfig] = useState<any>(null);
  const context = require.context('../lang', true, /.json$/);
  const locale = navigator.language;

  const {fetchConfig, configProp} = props;

  const allLanguages: any = {};
  context.keys().forEach((key: any) => {
    const fileName = key.replace('./', '');
    const resource = require(`../lang/${fileName}`);
    const namespace: string = fileName
      .replace('.json', '')
      .replaceAll('-', '_');
    allLanguages[namespace] = JSON.parse(JSON.stringify(resource));
  });

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  useEffect(() => {
    if (configProp) {
      setConfig(configProp);
    }
  }, [configProp]);

  return (
    <Fragment>
      {config?.localizationFile && (
        <IntlProvider
          locale={locale}
          messages={allLanguages[config.localizationFile]}
        >
          <div className="position-absolute start-0 top-0 w-100 vh-100 inicio"></div>
          <div className="position-absolute start-0 top-0 w-100 d-flex align-items-end vh-100">
            <Container>
              <Row>
                <Col className="d-flex justify-content-center">
                  <img
                    src={configProp.styles.logo}
                    alt="Logo"
                    className="img-fluid mt-2"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <h1 className="text-center text-white">
                    <FormattedMessage
                      id="thank_you"
                      defaultMessage="thank_you"
                    />
                  </h1>
                </Col>
              </Row>
            </Container>
          </div>
          <StyleConfig />
        </IntlProvider>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    configProp: state.configReducer.siteConfig,
  };
};
export default connect(mapStateToProps, {fetchConfig})(Index);
